import {
  GetOrders200Response,
  SideResponse,
} from "../../../codegen-api";
import { IPriceSize } from "../../../interfaces/Orderbook";
import { OrderbookFilterEnum } from "../../Perps/TradeOrderbookSection/shared";

export const headers = ["Price / IV", "Size", "Cumulative"] as const;
export type IHeaderType = (typeof headers)[number];

type HeaderFlex = {
  [key in IHeaderType]: number;
};
export const headerFlex: HeaderFlex = {
  "Price / IV": 1.5,
  Size: 4,
  Cumulative: 5,
};

export interface ISpreadProps {
  price: string;
  size: string;
  cumulativeSize: number;
  sizeIsUSD: boolean;

  iv?: string;
  sizeDecimals: number;
  priceDecimals: number;
  accountSize: number;
  totalSize: number;
  color: string;
  textColor: string;
  type: "bid" | "ask";
  index: number;
  rowHeight?: string;
}

export const maxCumulativeFillPercent = 0.5;

export interface ITradeOrderbookProps {
  bids: IPriceSize[];
  asks: IPriceSize[];
  sizeDecimals: number;
  priceDecimals: number;
  accountOrders: GetOrders200Response[];
  instrumentId?: string;
  onRowClick: (price: string, size: string, side: SideResponse) => void;
  middleRow?: JSX.Element;
  showIV: boolean;
  filter?: OrderbookFilterEnum;
  markPrice?: number;
  indexPrice?: number;
  // % away from index price that a trade is allowed
  indexPriceCollar: number;
  headerRowHeight?: string;
  rowHeight?: string;
  showValueInUSD?: boolean;
  orderbookTicksize?: number | undefined;
}
